export interface Branding {
  productName: string;
  logoUrl: string | null;
  primaryColor: string;
}

export const DEFAULT_BRANDING: Branding = {
  productName: 'Sentinel',
  logoUrl: null,
  primaryColor: 'oklch(47.34% 0.1717 353.56)',
};

/** Fallback logo URL for surfaces rendered on the dark Sentinel app surface.
 *  Use when `useBranding().logoUrl` is null — i.e. no tenant override is in
 *  effect. The asset is served by the gateway at this exact root-relative
 *  path; see `crates/sentinel-web/src/routes/assets.rs`. */
export const SENTINEL_DARK_LOGO_URL = '/logo-dark.svg';
